import * as React from "react";
import type { SVGProps } from "react";
const SvgClockCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m15 14.4-3.6-1.2V8.182M21 12a9.6 9.6 0 1 0-7.8 9.432m2.4-2.832 1.8 1.8 4.8-4.8"
    />
  </svg>
);
export default SvgClockCheck;
